import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppProfile } from '../../../shared/app-profile/app-profile';

@Injectable({
    providedIn: 'root'
})
export class OrgService {
    constructor(
        private readonly http: HttpClient, 
        private readonly authSvc: AuthService,
        private readonly appProfile: AppProfile
    ) {}

    getOrgTypes(token: string): Observable<any> {
        const headers = this.authSvc.getCommonHeaders(token, '1.0.0');
        return this.http.get(`${this.appProfile.epUs}/organization-ms/organization/organization-types`, { headers });
    }

    createOrg(company: any, token?: string): Observable<any> {
        if (token) {
            const headers = this.authSvc.getCommonHeaders(token, '1.0.0');
            return this.http.post(`${this.appProfile.epUs}/organization-ms/organization`, company, { headers });
        }
    }
}


//
